import { Injectable } from '@angular/core';
// import { Network } from '@awesome-cordova-plugins/network/ngx';
import { Network } from '@capacitor/network';
import { Platform } from '@ionic/angular';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private isOnlineSubject = new Subject<boolean>();

  constructor(
    private platform: Platform
  ) { }

  connectionStatus() {
    Network.addListener('networkStatusChange', ({ connected }) => {
      this.isOnlineSubject.next(connected);
    });
  }

  getConnectionStatus(): Observable<boolean> {
    return this.isOnlineSubject.asObservable();
  }

  async getInitialConecctionState() {
    if (!this.platform.is('android') || !this.platform.is('ios'))
      return true;
    const { connected } = await Network.getStatus();
    return connected;
  }


  getPlatform() {
    return localStorage.getItem('platform');
  }
}
